<template>
  <div id="app">
    <header>
      <h1>Anatomy Atlas</h1>
    </header>
    <tabbed-panel tabstr="About,Thorax,Abdomen,Pelvis">
      <about slot="About"></about>
      <slice-view title="Thorax" plan="thorax" sprite="thorax" slot="Thorax"></slice-view>
      <slice-view title="Abdomen" w="9216" plan="abdomen" sprite="abdomen" slot="Abdomen"></slice-view>
      <slice-view title="Pelvis" w="7680" plan="pelvis" sprite="mpelvis" slot="Pelvis"></slice-view>
    </tabbed-panel>
  </div>
</template>

<script>
import tabbedPanel from './components/tabbed-panel.vue'
import sliceView from './components/slice-view.vue'
import about from './components/about.vue'


export default {
  name: 'App',
  components: {
    tabbedPanel, sliceView, about
  }
}
</script>

<style>
header {
  margin-bottom: 1.6em;
}
@media all and (-ms-high-contrast: none) {
  header>h1::after {
    content: "This is an unsupported browser";
    color: orangered;
  }
  header+* {
    opacity:0.0125;
  }
}
</style>
